module.exports = __webpack_public_path__ + "static/media/Justin.43ee0365.jpg";